import Cookies from 'universal-cookie';
import Constants from '../utils/Constants';

const cookies = new Cookies();

// the BFF owns sub and sid now. logout still purges the cookie earlier builds wrote.
const clearUserInfoCache = () => {
  cookies.remove(Constants.USER_INFO_STORAGE_NAME, Constants.COOKIE_OPTIONS);
  cookies.remove(Constants.USER_INFO_STORAGE_NAME, { path: '/' });
};

export {
  clearUserInfoCache
};
